<script lang="ts">
    import {createEventDispatcher} from "svelte";

    export let value: number;
    const dispatch = createEventDispatcher();

    function plus() {
        value = value + 1;
        dispatch('updateQuantity');
    }

    function minus() {
        value = value - 1;
        if (value <= 0) {
            value = 1;
        }
        dispatch('updateQuantity');
    }

</script>
<div>
    <div class="grid-3 gap-i">
        <div class="btn-number" on:click="{minus}">
            -
        </div>
        <div class="box">
            {value}
        </div>
        <div class="btn-number" on:click={plus}>
            +
        </div>
    </div>
</div>
<style>
    .btn-number {
        font-family: sans-serif;
        background: var(--bg-gray);
        height: 30px;
        width: 30px;
        border-radius: 50%;
        color: var(--text-gray);
        font-weight: bold;
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>